import {
  $primaryColorsGreen,
  styled
} from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import { resolvePath } from "@utils/resolvePath";

export const AddonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 0.5rem;
`;

export const AddonName = styled.h1`
  color: #451999;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  margin: 0px;
`;

export const DetailsWrapper = styled.div`
  padding: 16px;
`;

export const Description = styled(Text)`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #5b5675;

  ul {
    margin-top: 0px;
    padding: 0px;
    margin-left: 10px;
  }

  li {
    margin-top: 0.5rem;
  }
`;

export const Price = styled(Text)`
  color: #040222;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  margin: 4px 0px 12px;
`;

export const StrikeThroughPrice = styled.span`
  color: #5b5675;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  margin-left: 8px;
  text-decoration: line-through;
`;

export const AddonCardWrapper = styled.div`
  border: 1px solid
    ${(props) => (props.selected ? $primaryColorsGreen.normal : "#e7e7f0")};
  border-radius: 0.75rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  background-image: url(${resolvePath("/images/planCardGradient.svg")});
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
`;

export const ModalHeading = styled.p`
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  color: #040222;
  margin: 0px;

  span {
    color: #7c47e1;
  }
`;

export const FreeUpgradeTag = styled.span`
  display: flex;
  width: max-content;
  padding: 4px 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 20px;
  background: var(--Maroon-M50, #fbe9f6);
  margin-bottom: 12px;
`;

export const FreeUpgradeTagLabel = styled.span`
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: -0.1px;
  background: linear-gradient(269deg, #f16262 -10.35%, #743ddc 106.34%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
`;

export const Tag = styled.span`
  width: max-content;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  background: ${(props) =>
    props?.isPlusVariant
      ? "linear-gradient(180deg, #8550EB 0%, #A847C1 100%);"
      : "#E0E0E8"};

  color: ${(props) => (props?.isPlusVariant ? "#FFF" : "#5B5675")};
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 1rem;

  @media (min-width: 768px) {
    margin-top: 1rem;
  }
`;
